<script>

  /**
   * 统一认证服务器地址
   */

  const ssoServer = process.env.REQUEST_BASE_URL; // 线上环境
  const ssoServerimg = `${ssoServer}/api/file/upload`; //线上图片环境




  export default
  {
    ssoServer,
    ssoServerimg
    // ssoServerLogout

  }

</script>



// WEBPACK FOOTER //
// src/views/Global.vue